module.exports = __webpack_public_path__ + "build/assets/STIXTwoMath-Regular-cb418355a5de2f20d5db76cde276a6f8.woff2";